import z from 'zod'

export const createEmployeeFormSchema = z.object({
  firstName: z.string().min(1, { message: 'Поле не может быть пустым' }),
  lastName: z.string().min(1, { message: 'Поле не может быть пустым' }),
  middleName: z.string(),
  iin: z.string().min(12, { message: 'Поле не может быть пустым' }),
  position: z.string(),
})
